import { Link, useLocation } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

export default function Nav() {
  const loc = useLocation();
  const onHome = loc.pathname === "/";
  const { t, lang, setLang } = useI18n();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-nav">
      <div className="max-w-[1400px] mx-auto px-4 md:px-12 py-4 md:py-5 flex items-center justify-between gap-3">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 flex-shrink-0">
          <img src="/brand/logo-wreath-transparent.png" alt="Ithaca Garden Villa" className="h-9 md:h-10 w-auto" />
          <span className="hidden xl:inline font-serif text-lg md:text-xl text-ionian tracking-[0.16em] uppercase whitespace-nowrap">Ithaca Garden Villa</span>
        </Link>
        <nav className="hidden md:flex items-center gap-5 lg:gap-8">
          {onHome ? (
            <>
              <a href="#story" data-testid="nav-story" className="overline text-ionian/70 hover:text-ionian">{t("nav.story")}</a>
              <a href="#gallery" data-testid="nav-gallery" className="overline text-ionian/70 hover:text-ionian">{t("nav.gallery")}</a>
              <a href="#location" data-testid="nav-location" className="overline text-ionian/70 hover:text-ionian">{t("nav.location")}</a>
              <a href="#contact" data-testid="nav-contact" className="overline text-ionian/70 hover:text-ionian">{t("nav.contact")}</a>
            </>
          ) : (
            <Link to="/" data-testid="nav-home" className="overline text-ionian/70 hover:text-ionian">{t("nav.home")}</Link>
          )}
          <LangToggle lang={lang} setLang={setLang} />
          <Link
            to="/booking"
            data-testid="nav-book-btn"
            className="btn-brass px-5 lg:px-6 py-2.5 rounded-full text-sm font-medium tracking-wide whitespace-nowrap"
          >
            {t("nav.reserve")}
          </Link>
        </nav>
        <div className="md:hidden flex items-center gap-2 flex-shrink-0">
          <LangToggle lang={lang} setLang={setLang} />
          <Link to="/booking" data-testid="nav-book-btn-mobile" className="btn-brass px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap">
            {t("nav.reserve")}
          </Link>
        </div>
      </div>
    </header>
  );
}

function LangToggle({ lang, setLang }) {
  return (
    <div data-testid="lang-toggle" className="flex items-center border border-soft_border rounded-full overflow-hidden text-[10px] tracking-widest font-semibold">
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1.5 uppercase transition-colors ${lang === "en" ? "bg-ionian text-stone_white" : "text-ionian/60 hover:text-ionian"}`}
      >
        EN
      </button>
      <button
        data-testid="lang-gr"
        onClick={() => setLang("gr")}
        className={`px-3 py-1.5 uppercase transition-colors ${lang === "gr" ? "bg-ionian text-stone_white" : "text-ionian/60 hover:text-ionian"}`}
      >
        GR
      </button>
    </div>
  );
}
